<template>
  <md-menu ref="menu" class="autocomplete" :md-offset-y="0.1" @md-opened="onMenuOpened">
    <div ref="searchInputContainer" class="search">
      <md-icon v-if="showSearchIcon">search</md-icon>
      <md-field
        class="md-autocomplete md-focused md-active"
        :style="{background: 'white'}"
        md-menu-trigger
      >
        <md-input
          :id="inputId"
          v-model="state.searchTerm"
          v-bind="$attrs"
          autocomplete="off"
          v-on="$listeners"
          @input="search"
        />
      </md-field>
    </div>
    <md-menu-content v-show="results.length" ref="menuContent">
      <md-menu-item
        v-for="result in results"
        :key="result.id"
        @click="event => selectResult(result, event)"
      >
        <!-- Highlight text does not behave well when search term is not included in label
        This might happen during asynchronous search with stale results -->
        <md-highlight-text
          v-if="result.label && result.label.toLowerCase().includes(state.searchTerm && state.searchTerm.toLowerCase())" :md-term="state.searchTerm"
        >
          {{ result.label }}
        </md-highlight-text>
        <span v-else>{{ result.label }}</span>
        <md-button v-if="showAddButton" class="md-icon-button md-dense md-raised md-primary">
          <md-icon>add</md-icon>
        </md-button>
      </md-menu-item>
    </md-menu-content>
  </md-menu>
</template>

<script>
export default {
  name: 'autocomplete',
  props: {
    results: {
      type: Array,
      default: () => ([])
    },
    value: {
      type: String,
      default: '',
    },
    showAddButton: {
      type: Boolean,
      default: true,
    },
    showSearchIcon: {
      type: Boolean,
      default: true,
    },
    inputId: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      state: {
        searchTerm: ''
      }
    };
  },
  watch: {
    value(newVal) {
      this.state.searchTerm = newVal;
    }
  },
  methods: {
    selectResult(result, event) {
      this.repositionMenu();
      // When the menu item is selected through a keyboard enter
      // vue-material dispatches an event themselve, so the isTrusted
      // property is false (vs a click on the item)
      const isKeyboardSelect = !event.isTrusted;
      const highlightedMenuItem = document.querySelector('.md-menu-item.md-highlight');
      if (isKeyboardSelect && !highlightedMenuItem) {
        return;
      }
      this.$emit('selectResult', result);
    },
    search(term) {
      this.$emit('search', term);
      this.$emit('input', term);
      if (this.$refs.menu && !this.$refs.menu.isActive) {
         this.$refs.menu.toggleContent();
      }
    },
    onMenuOpened() {
      setTimeout(() => {
        const { searchInputContainer, menuContent } = this.$refs;
        if (searchInputContainer && menuContent) {
          // menuContent is simply a comment node
          const menuListItem = menuContent.$children[0];
          if (menuListItem && menuListItem.$el) {
            menuListItem.$el.style.width = `${searchInputContainer.offsetWidth - 25}px`;
          }
        }
      });
    },
    repositionMenu() {
      this.$refs.menuContent.setPopperSettings();
    }
  },
};
</script>

<style>
.autocomplete-result {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>